export const IMMIGRATION_OPTIONS = {
  'Fleeing Persecution': [
    {
      identifier: 'fleeing-persecution-asylum',
      category: 'Fleeing Persecution',
      shortTitle: 'Asylum',
      legalReference: 'INA § 208',
      summary: 'Physically present in the US who reasonably fear that they will be or have been persecuted based on their race, religion, nationality, political opinion, or membership in a particular social group if returned to their home country. Failure to apply within one year, crimes, and other factors render ineligible. Discretionary. Indefinite status; pathway to permanent residence; family members eligible. ',
    },
    {
      identifier: 'fleeing-persecution-statutory-withholding',
      category: 'Fleeing Persecution',
      shortTitle: 'Statutory Withholding',
      legalReference: 'INA § 241(b)(3)',
      summary: 'Protects individuals who are more likely than not will be persecuted on account of race, religion, nationality, political opinion, or membership in particular social group. Crime and similar bars. Mandatory if eligible. Limited benefits; may result in removal to a different country. ',
    },
    {
      identifier: 'fleeing-persecution-cat-withholding',
      category: 'Fleeing Persecution',
      shortTitle: 'CAT Withholding',
      legalReference: '8 CFR § 1208.16',
      summary: 'Protects individuals who are more likely than not to be tortured if they were removed to the proposed country of removal.  No nexus required; torture specifically defined; crime and similar bars. Limited benefits; may result in removal to a different country.',
    },
    {
      identifier: 'fleeing-persecution-cat-deferral',
      category: 'Fleeing Persecution',
      shortTitle: 'CAT Deferral',
      legalReference: '8 CFR § 1208.17',
      summary: 'Protects individuals who are more likely than not to be tortured if they were removed to the proposed country of removal.  No nexus required; torture specifically defined; no bars. Very limited benefits; may result in removal to a different country.',
    },
    {
      identifier: 'fleeing-persecution-asylee-relative-petition-(i-730)',
      category: 'Fleeing Persecution',
      shortTitle: 'Asylee Relative Petition (I-730)',
      legalReference: 'INA § 207(c)(2); INA § 208(b)(3)',
      summary: 'People who were granted asylum or are refugees as a principal can file an I-730 to allow their spouse and unmarried children under 21 to come to the US under derivative asylee or refugee status or to derive such status from within the U.S.. ',
    },
    {
      identifier: 'fleeing-persecution-afghan-parole-program',
      category: 'Fleeing Persecution',
      shortTitle: 'Afghan Parole Program',
      legalReference: '',
      summary: 'Provides departure assistance for eligible family members who are outside the United States of Afghan national who entered the United States as a parolee and is currently a parolee or was paroled into the United States and later granted TPS. Provides limited exemptions from inadmissibility grounds. Pathway to permanent residence',
    },
    {
      identifier: 'fleeing-persecution-ukraine-parole-program',
      category: 'Fleeing Persecution',
      shortTitle: 'Ukraine Parole Program',
      legalReference: '',
      summary: 'Provides a pathway for Ukrainian citizens and their immediate family members who are outside the United States to come to the United States and stay temporarily in a 2 year period of parole. Must have a supporter in the United States who agrees to provide them with financial support for the duration of their stay in the United States. Defines supporter.',
    },
    {
      identifier: 'fleeing-persecution-cuban-adjustment-act',
      category: 'Fleeing Persecution',
      shortTitle: 'Cuban Adjustment Act',
      legalReference: '',
      summary: 'Provides permanent residence to Cuban national who was inspected and admitted or paroled into the US. Requires one year physical presence. Discretionary. Exemptions from 245(c) bars; exemptions from several inadmissibility grounds; eligibility extends to spouse and child regardless of nationality.',
    },
    {
      identifier: 'fleeing-persecution-haitian-family-reunification',
      category: 'Fleeing Persecution',
      shortTitle: 'Haitian Family Reunification',
      legalReference: '',
      summary: 'Provides parole for relatives of Haitian nationals who are USCs or LPRs and who have filed I-130 petitions where visa number not available; by special invitation of DOS.',
    },
    {
      identifier: 'fleeing-persecution-cuban-family-reunification',
      category: 'Fleeing Persecution',
      shortTitle: 'Cuban Family Reunification',
      legalReference: '',
      summary: 'Provides parole for relatives of Haitian nationals who are USC or LPRs and who have filed I-130 petitions; by special invitation of DOS. Program is dormant.',
    },
    {
      identifier: 'fleeing-persecution-asylee-adjustment',
      category: 'Fleeing Persecution',
      shortTitle: 'Asylee Adjustment',
      legalReference: 'INA 209',
      summary: 'Permits asylee with at least one year phyiscal presence and status to seek permanent residence; most inadmissibility grounds exempted or waivable. ',
    },
    {
      identifier: 'fleeing-persecution-tps',
      category: 'Fleeing Persecution',
      shortTitle: 'TPS',
      legalReference: 'INA § 244',
      summary: 'Provides temporary work authorization, release from detention, and protection from removal for individuals from designated countries (ongoing armed conflict (such as civil war); an environmental disaster (such as earthquake or hurricane), or an epidemic; or other extraordinary and temporary conditions); travel authorization allowed under separate application. Registration required. Late registration permitted in some cases. Crime and similar bars apply.',
    },
    {
      identifier: 'fleeing-persecution-refugee-adjustment',
      category: 'Fleeing Persecution',
      shortTitle: 'Refugee Adjustment',
      legalReference: 'INA § 209',
      summary: 'Permits asylee with at least one year phyiscal presence and status to seek permanent residence; most inadmissibility grounds exempted or waivable. ',
    },
    {
      identifier: 'fleeing-persecution-siv-afghan',
      category: 'Fleeing Persecution',
      shortTitle: 'SIV Afghan',
      legalReference: '',
      summary: 'Provides special immigrant visa to eligible Afghans who were employed by or on behalf of the U.S. government, the International Security Assistance Force (ISAF) or a successor mission in Afghanistan between Oct. 7, 2001, and Dec. 31, 2023, for a minimum of 1 year and have provided faithful and valuable service to the U.S. government, ISAF or successor mission as documented in a positive letter of recommendation; and experienced or are experiencing an ongoing serious threat as a consequence of employment.',
    },
    {
      identifier: 'fleeing-persecution-central-american-minors-program',
      category: 'Fleeing Persecution',
      shortTitle: 'Central American Minors Program',
      legalReference: '',
      summary: 'Provides certain qualified children who are nationals of El Salvador, Guatemala, and Honduras, as well as certain family members of those children an opportunity to apply for refugee status and possible resettlement in the United States. Only certain parents or legal guardians who are lawfully present in the United States may request access to the program for qualifying children. A qualified child must be unmarried, under the age of 21, and a national of El Salvador, Guatemala, or Honduras. In some cases, an in-country parent of the qualifying child may also qualify for access. Children of a qualifying child or of other eligible family members may also qualify, if those children are under the age of 21 and unmarried. If ineligible for refugee status, parole is generally available. ',
    },
    {
      identifier: 'fleeing-persecution-el-salvadoran-family-reunification-parole-program',
      category: 'Fleeing Persecution',
      shortTitle: 'El Salvadoran Family Reunification Parole Program',
      legalReference: '',
      summary: 'Provides parole for relatives of El Salvadoran nationals who are USCs or LPRs and who have filed I-130 petitions where visa number not available; by special invitation of DOS only.',
    },
    {
      identifier: 'fleeing-persecution-guatemalan-family-reunification-parole-program',
      category: 'Fleeing Persecution',
      shortTitle: 'Guatemalan Family Reunification Parole Program',
      legalReference: '',
      summary: 'Provides parole for relatives of Guatemalan nationals who are USCs or LPRs and who have filed I-130 petitions where visa number not available; by special invitation of DOS only.',
    },
    {
      identifier: 'fleeing-persecution-honduran-family-reunification-parole-program',
      category: 'Fleeing Persecution',
      shortTitle: 'Honduran Family Reunification Parole Program',
      legalReference: '',
      summary: 'Provides parole for relatives of Honduran nationals who are USCs or LPRs and who have filed I-130 petitions where visa number not available; by special invitation of DOS only.',
    },
    {
      identifier: 'fleeing-persecution-colombian-family-reunification-parole-program',
      category: 'Fleeing Persecution',
      shortTitle: 'Colombian Family Reunification Parole Program',
      legalReference: '',
      summary: 'Provides parole for relatives of Colombian nationals who are USCs or LPRs and who have filed I-130 petitions where visa number not available; by special invitation of DOS only.',
    },
  ],
  Defensive: [
    {
      identifier: 'defensive-lpr-cancellation',
      category: 'Defensive',
      shortTitle: 'LPR Cancellation',
      legalReference: 'INA § 240A(a)',
      summary: 'Cancels removal for lawful permanent residents who are removable. Relief is only available once per individual. Discretionary. Numerous limitations and exceptions apply to limit availability relief.  ',
    },
    {
      identifier: 'defensive-non-lpr-cancellation',
      category: 'Defensive',
      shortTitle: 'Non-LPR Cancellation',
      legalReference: 'INA § 240A(b)',
      summary: 'Cancels removal of certain noncitizens in removal proceedings with at least 10 years of residence in the US, good moral character, and a USC or LPR spouse, child or parent who would suffer exceptional and extremely unusual hardship. Numerous limitations and ineligibilities. Provides permanent residence if granted.',
    },
    {
      identifier: 'defensive-voluntary-departure',
      category: 'Defensive',
      shortTitle: 'Voluntary Departure',
      legalReference: 'INA §  240B',
      summary: 'Permission to leave the country in a manner that has fewer negative conseqeunces (e.g., time bars to return) than being removed',
    },
    {
      identifier: 'defensive-vawa-cancellation-',
      category: 'Defensive',
      shortTitle: 'VAWA Cancellation ',
      legalReference: 'INA § 240A(b)(2)',
      summary: "Provides defense to removal that results in permanent residence to noncitizens with 3 years physical presence, GMC, and who were subjected to extreme cruelty by a U.S. citizen/LPR spouse or parent. Alternative eligibility if applicant's child was battered or subjected to extreme cruelty by U.S. citizen/LPR parent. Must prove removal would cause extreme hardship. Several limitations.",
    },
    {
      identifier: 'defensive-motion-to-terminate-',
      category: 'Defensive',
      shortTitle: 'Motion to Terminate ',
      legalReference: '',
      summary: 'If a motion to terminate is granted, dismissal of the matter is generally granted without prejudice. The agency may file the same charges at a later time (unless it is forcelosed from doing so).',
    },
    {
      identifier: 'defensive-motion-to-supress',
      category: 'Defensive',
      shortTitle: 'Motion to Supress',
      legalReference: '',
      summary: 'Provides basis to attack evidence in removal proceedings where evidence gathered through an egregious or wide spead violations of civil rights.',
    },
    {
      identifier: 'defensive-pcr',
      category: 'Defensive',
      shortTitle: 'PCR',
      legalReference: '',
      summary: 'Permits successful attack on underlying conviction to defeat removal where relief is based on procedural or substantive infirmities and not for immigration purposes.',
    },
    {
      identifier: 'defensive-admin-closure',
      category: 'Defensive',
      shortTitle: 'Admin Closure',
      legalReference: '8 CFR 1003 et seq',
      summary: 'Protects temporarily from removal by pausing active removal case; multi-factor test, often requires DHS agreement; may permit renewal of EAD where authorized by separate relief; recalendaring possible at any time',
    },
    {
      identifier: 'defensive-prosecutorial-discretion',
      category: 'Defensive',
      shortTitle: 'Prosecutorial discretion',
      legalReference: 'INA 237',
      summary: 'Protects against removal by using multi-factor test. Solely DHS decision. Often requires affirmative request and relinquishment of rights in proceedings.',
    },
    {
      identifier: 'defensive-fraud-deportation',
      category: 'Defensive',
      shortTitle: 'Fraud Deportation',
      legalReference: '237(a)(1)(H)',
      summary: 'Provides defense to removal for noncitizen who was wrongfully admitted to the United States due to a misrepresentation—i.e., those who were in fact inadmissible at time of admission. No form or fee required.  Limited to spouse, parent, son, or daughter of a U.S. citizen or permanent resident; must be otherwise admissible at time of admission. ',
    },
    {
      identifier: 'defensive-judicial-admin-closure',
      category: 'Defensive',
      shortTitle: 'Judicial Admin Closure',
      legalReference: '',
      summary: 'Limited option while on a petition for review at the Ninth Circuit; requires agreement of parties; similar to administrative closure.',
    },
  ],
  'Special Programs': [
    {
      identifier: 'special-programs-deferred-action-workers',
      category: 'Special Programs',
      shortTitle: 'Deferred Action Workers',
      legalReference: '',
      summary: 'Permits deferred action, continued presence, parole, and other relief to noncitizens who are witnesses to or victims of abusive and exploitative labor practices. Requires official investigation. Other limitations apply. ',
    },
    {
      identifier: 'special-programs-family-unity',
      category: 'Special Programs',
      shortTitle: 'Family Unity',
      legalReference: '',
      summary: 'Provides temporary status to spouses and children who did not themselves qualify under the amnesty programs and whose spouse or parent did.',
    },
    {
      identifier: 'special-programs-haitian-refugee-immigrant-fairness-act',
      category: 'Special Programs',
      shortTitle: 'Haitian Refugee Immigrant Fairness Act',
      legalReference: '',
      summary: 'Provides permanent residence to certain nationals of Haiti who had been residing in the United States. Principal applicants wishing to apply for permanent residence under HRIFA had until March 31, 2000 to file for adjustment of status. Although the filing period has closed for principal applicants, dependents of the principal filer may continue to apply for a green card under the HRIFA provisions.',
    },
    {
      identifier: 'special-programs-daca',
      category: 'Special Programs',
      shortTitle: 'DACA',
      legalReference: '',
      summary: 'Provides temporary deportation protection and a work permit to undocumented young people who meet certain conditions.',
    },
    {
      identifier: 'special-programs-nacara',
      category: 'Special Programs',
      shortTitle: 'NACARA',
      legalReference: '',
      summary: 'Provides permanent residence for Salvadoran, Guatemala, or former Soviet bloc countries who applied for asylum or similar relief in the early 1990’s are eligible for LPR status and can apply for cancellation or suspension of removal under the more lenient pre-1997 standards. Dependents eligible. Numerous limitations.',
    },
    {
      identifier: 'special-programs-diversity-visa-lottery',
      category: 'Special Programs',
      shortTitle: 'Diversity Visa Lottery',
      legalReference: 'INA §  203(c) ',
      summary: 'Provides permanent residence to nationals of undersubscribed countries; requires registration and random selection; other time, processing, and admissibility limitations.',
    },
    {
      identifier: 'special-programs-humanitarian-parole',
      category: 'Special Programs',
      shortTitle: 'Humanitarian Parole',
      legalReference: '212(d)',
      summary: 'Provides method for entry into the United States for humanitarian reasons on a case by case basis.',
    },
    {
      identifier: 'special-programs-parole-in-place',
      category: 'Special Programs',
      shortTitle: 'Parole in Place',
      legalReference: '',
      summary: 'Provides parole for those inside the United States without requiring a departure; limited to exceptional circumstances.',
    },
    {
      identifier: 'special-programs-military-parole-in-place',
      category: 'Special Programs',
      shortTitle: 'Military Parole in Place',
      legalReference: 'INA § 212(d)(5)',
      summary: 'Provides individuals with an immediate family member [spouse, parent, or child] in the US military may be allowed to obtain a valid parole to the US without leaving the country via "parole in place."',
    },
    {
      identifier: 'special-programs-special-immigrant-juvenile-status-(sijs)-',
      category: 'Special Programs',
      shortTitle: 'Special Immigrant Juvenile Status (SIJS) ',
      legalReference: 'INA § 101(a)(27)(J)',
      summary: 'Provides a pathway to LPR status for immigrant children who have been abused, abandoned, or neglected by one or both of their parents.',
    },
  ],
  'Law & Justice Visas': [
    {
      identifier: 'law-&-justice-visas-u-visa',
      category: 'Law & Justice Visas',
      shortTitle: 'U-Visa',
      legalReference: ' INA § 101(a)(15)(U)',
      summary: 'Provides nonimmigrant status to noncitizen victims of specified crime (generally person-crimes) who cooperate in investigation or prosecution of crime. Law enforcement certification required. Dependent family member eligibility. Family members of USC child victims eligible. Status is 4 years. Pathway to permanent residence after 3 years. Broad waivers to inadmissibility. Limited availability creates long wait list. Interim deferred action available. Lengthy process.  ',
    },
    {
      identifier: 'law-&-justice-visas-t-visa',
      category: 'Law & Justice Visas',
      shortTitle: 'T-Visa',
      legalReference: 'INA § 101(a)(15)(T)',
      summary: 'Provides nonimmigration status to noncitizen victims of labor or sex trafficking who cooperate with law enforcement in the investigation or qualify for an exemption or exception. No law enforcement certification required. Status is 4 years.  Pathway to permanent residence after 3 years. Broad waivers to inadmissibility. Dependent family member eligibility. ',
    },
    {
      identifier: 'law-&-justice-visas-s-visa',
      category: 'Law & Justice Visas',
      shortTitle: 'S-Visa',
      legalReference: 'INA § 101(a)(15)(S)',
      summary: 'Provides nonimmigration status to noncitizen informers of certain prosecutions. Requires law enforcement agreement and certification. ',
    },
  ],
  'Permanent Resident Status': [
    {
      identifier: 'permanent-resident-status-immediate-relative-petition',
      category: 'Permanent Resident Status',
      shortTitle: 'Immediate Relative Petition',
      legalReference: 'INA § 201',
      summary: 'Provides for classification as "immediate relative" for spouse, unmarried children, and parents of USC; creates pathway for permanent residence via adjustment or consular processing.  ',
    },
    {
      identifier: 'permanent-resident-status-preference-relative-petition',
      category: 'Permanent Resident Status',
      shortTitle: 'Preference Relative Petition',
      legalReference: 'INA § 203',
      summary: 'Provides for classification as "preference relative" for spouse, unmarried children, adult children  of LPRs and adult children, married children, and siblings of USCs; dependent family members included. Creates pathway for permanent residence via adjustment or consular processing when visa available. ',
    },
    {
      identifier: 'permanent-resident-status-k-visa-for-fiance-of-usc',
      category: 'Permanent Resident Status',
      shortTitle: 'K visa for fiance of USC',
      legalReference: 'INA § 314(d)',
      summary: 'US citizens can petition for their fiances who are located outside of the US to obtain a non-immigrant K-visa which allows them to enter the US and get married within 90 days, and then adjust their status to a green card. ',
    },
    {
      identifier: 'permanent-resident-status-widow-petition',
      category: 'Permanent Resident Status',
      shortTitle: 'Widow Petition',
      legalReference: '',
      summary: 'Provides classification of immediate relative to widows or widowers who were married to U.S. citizens at the time of the citizen’s death; pathway to permanent residence via adjustment or consular processing.',
    },
    {
      identifier: 'permanent-resident-status-vawa-self-petition',
      category: 'Permanent Resident Status',
      shortTitle: 'VAWA Self Petition',
      legalReference: 'INA § 201',
      summary: 'Provides for immediate relative or preference relative classification, and pathway to permanent residence, for victim of battery or extreme cruelty committed by U.S. citizen spouse or former spouse; U.S. citizen parent;U.S. citizen son or daughter; a lawful permanent resident (LPR) spouse or former spouse; or an LPR parent.',
    },
    {
      identifier: 'permanent-resident-status-adjustment',
      category: 'Permanent Resident Status',
      shortTitle: 'Adjustment',
      legalReference: 'INA § 245(a)',
      summary: 'Provides mechanism for obitaining permanent residence for noncitizens inspected and admitted or paroled; must be in status without status violations; exceptions for immediate relatives; discretionary. Other limitations.',
    },
    {
      identifier: 'permanent-resident-status-penalty-adjustment',
      category: 'Permanent Resident Status',
      shortTitle: 'Penalty Adjustment',
      legalReference: 'INA § 245(i)',
      summary: 'Provides mechanism for obitaining permanent residence for noncitizens present without admission or parole in spite of status violations if qualifying petition filed on or before April 30. 2001 and physical presence on December 21, 2000; no presence required if qualifying petition filed on or before January 14, 1998. Penalty fee required. Grandfathered status permitted. Certain derivatives also eligible without needing independent eligibility. ',
    },
    {
      identifier: 'permanent-resident-status-consular-processing',
      category: 'Permanent Resident Status',
      shortTitle: 'Consular Processing',
      legalReference: 'INA § 221',
      summary: 'Provides mechanism for obtaining permanent residence via US consular offices; must have qualifying petition or other eligibility for immigrant visa',
    },
    {
      identifier: 'permanent-resident-status-registry',
      category: 'Permanent Resident Status',
      shortTitle: 'Registry',
      legalReference: 'INA § 249',
      summary: 'Provides permanent residence for noncitizens present in the US since 1972. Other eligibility and limitations apply. ',
    },
  ],
  Waivers: [
    {
      identifier: 'waivers-health',
      category: 'Waivers',
      shortTitle: 'Health',
      legalReference: 'INA § 212(g)',
      summary: '',
    },
    {
      identifier: 'waivers-ideology',
      category: 'Waivers',
      shortTitle: 'Ideology',
      legalReference: 'INA § 212(a)(3)(D)',
      summary: 'Waives inadmissibility for ideological grounds. Also, there are exceptions relating to past membership and/or involuntary membership.',
    },
    {
      identifier: 'waivers-misrep',
      category: 'Waivers',
      shortTitle: 'Misrep',
      legalReference: 'INA § 212(i)',
      summary: 'Waives inadmissibility for misrepresentations or fraud; limited to spouse, son or daughter of USC or LPR; must demonstrate extreme hardhsip; does not waive false claims to USC; VAWA self petitioner exemptions. Other limitations.',
    },
    {
      identifier: 'waivers-crime-&-vice',
      category: 'Waivers',
      shortTitle: 'Crime & Vice',
      legalReference: 'INA § 212(h)',
      summary: 'Waives crime, drug, and other related inadmissibility; highly nuanced; LPRs may not be eligible; may have to demonstrate extreme hardship and extensive positive discretionary factors; rehabilitation may be required; passage of 15 years may provide alternative eligibility.   ',
    },
    {
      identifier: 'waivers-documents',
      category: 'Waivers',
      shortTitle: 'Documents',
      legalReference: 'INA § 212(k)',
      summary: 'Waives defects in documents or status issues; no form or fee required; applies only when the applicant has arrived at a port of entry in possession of an immigrant visa which was defective for reasons that were unknown or could not have been reasonably discovered. ',
    },
    {
      identifier: 'waivers-ulp-3/10',
      category: 'Waivers',
      shortTitle: 'ULP 3/10',
      legalReference: 'INA § 212(a)(9)(B)(v)',
      summary: 'Waives inadmissibility for ULP (3 or 10 years) if spouse or parent would suffer extreme hardship.',
    },
    {
      identifier: 'waivers-perm-bar',
      category: 'Waivers',
      shortTitle: 'Perm Bar',
      legalReference: 'INA § 212(a)(9)(C)',
      summary: 'No waiver; consent to reapply permitted after passage of 10 years outside the US.',
    },
    {
      identifier: 'waivers-civil-penalty',
      category: 'Waivers',
      shortTitle: 'Civil Penalty',
      legalReference: 'INA § 212(d)(12)',
      summary: 'Waives document fraud or civil penalty adjudications; limited applicability.',
    },
    {
      identifier: 'waivers-asylee-',
      category: 'Waivers',
      shortTitle: 'Asylee ',
      legalReference: 'INA § 209(c)',
      summary: 'Waives most inadmissibility grounds for asylees or refugees adjusting status; generous standard.',
    },
    {
      identifier: 'waivers-alien-smuggling',
      category: 'Waivers',
      shortTitle: 'Alien Smuggling',
      legalReference: 'INA § 212(a)(6)(E)(ii)',
      summary: 'Waives inadmissibility for noncitizen who aided smiuggling (broadly defined) an individual who at the time was the noncitizens’s spouse, parent, son, or daughter. generous standard including humanitarian reasons, public interest, or family unity. ',
    },
    {
      identifier: 'waivers-consent-to-reapply',
      category: 'Waivers',
      shortTitle: 'Consent to reapply',
      legalReference: 'INA § 212(a)(9)(A)',
      summary: 'No waiver, permits consent to reapply after specific criteria satisifed for individuals previously removed; operates like a waiver.',
    },
  ],
  Citizenship: [
    {
      identifier: 'citizenship-birth',
      category: 'Citizenship',
      shortTitle: 'Birth',
      legalReference: '',
      summary: 'Born in the United States',
    },
    {
      identifier: 'citizenship-derivative-us-citizenship',
      category: 'Citizenship',
      shortTitle: 'Derivative US Citizenship',
      legalReference: 'INA § 320',
      summary: 'U.S. citizenship (derived after birth through parent becoming U.S. citizens, or if U.S. citizens become parents through adoption).',
    },
    {
      identifier: 'citizenship-acquired-us-citizenship',
      category: 'Citizenship',
      shortTitle: 'Acquired US Citizenship',
      legalReference: 'INA § 301',
      summary: 'U.S. citizenship (acquired at birth or after birth, before the age of 18 where born in foreign country to U.S. citizen parent). ',
    },
    {
      identifier: 'citizenship-naturalization',
      category: 'Citizenship',
      shortTitle: 'Naturalization',
      legalReference: 'INA § 316',
      summary: 'U.S. citizenship for permanent residents after 5 years; requires continuous residence, good moral character, good status, and other qualifications. English language and civics required. Exemptions available for medical reasons, age, and disability. May lead to deportation if status defects or post-admission criminal activity. 3-year period for spouse of USC. Other limitations and eligibility criteria. ',
    },
    {
      identifier: 'citizenship-naturalization---military',
      category: 'Citizenship',
      shortTitle: 'Naturalization - Military',
      legalReference: 'INA § 328',
      summary: 'U.S. citizenship through service in military during declared conflict.',
    },
  ],
}

export const ANALYSIS_STATUS = [
  {
    name: 'Yes',
    key: 'yes',
    val: '',
    color: 'success',
  },
  {
    name: 'No',
    key: 'no',
    val: '',
    color: 'error',
  },
  {
    name: 'Maybe',
    key: 'maybe',
    val: '',
    color: 'warning',
  },
  {
    color: 'warning',
    key: 'not-at-this-time',
    name: 'Not at this time',
    val: '',
  },
  {
    name: 'No Analysis',
    key: 'no-analysis',
    val: '',
    color: 'grey',
  },
  {
    name: 'Waiver/Exception',
    key: 'waiver-exception',
    val: '',
    color: 'purple',
  },
]
